export default "__VITE_ASSET__3G0c5Hxs__"